import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom';

import sanitizeHtml from 'sanitize-html';

import useFetch from '../../../../hook/useFetch'

import { useDispatch, useSelector } from 'react-redux'

import { getLandingPage } from '../../../../pages/features/landingpage/landingpageSlice'


import { colors } from '../../../../colors'
import { external } from '../../../../assets'
import { 
    Container,
    HeaderContainer,
    NavLink, 
} from '../popularcategories'

import { Tags } from '../../../../components/newPaperFeedCard'

import { ExternalResourcesData } from '../../../../externalresdata'

import { 
    InnerContainer,
    ImageContainer,
 } from '../../../../components/newPaperFeedCard'


const ExternalResources = ({tags}) => {

    const dispatch = useDispatch

    const { landingPage, landingStatus} = useSelector(state => state?.landingPage)
    useFetch(getLandingPage);

    // console.log(landingPage.recentlyCreatedExternalResources);

    const convertStringToHTML = function (str) {
        let parser = new DOMParser()
        let doc = parser.parseFromString(str, 'text/html')

        // console.log(doc);

        // console.log(doc.body.getElementsByTagName("p"))
        return doc.body
    }


  return (
    <Container>
         <HeaderContainer>
            <h2>Open Access Publications</h2>
            <h5> <NavLink to='/open-access-resources' >View all</NavLink> </h5>
        </HeaderContainer>

        <ContContainer>

            {

landingPage?.recentlyCreatedExternalResources?.slice(0, 6).map((extres) => {
    // console.log(convertStringToHTML(extres?.resourceDescription), 'converted');
        return(
            <ExternalContainer key={extres?.resourceId} >
            <LinkToDetails to={`/open-access/resource/${extres?.resourceNlnCode}`} >
                <InnerContainer>
                <ImageContainer src={extres?.resourceImage} alt='newspaper_icon' />

                    <Title>
                        <h4>
                            {extres?.resourceTitle}
                        </h4>
                        <h5 dangerouslySetInnerHTML={{ __html: sanitizeHtml(extres?.resourceDescription) }} />
                        {/* <p dangerouslySetInnerHTML={{ __html: char }} /> */}
    
                    </Title>
                </InnerContainer>
            </LinkToDetails>
        </ExternalContainer>

        )
    })
            
            
            }
        </ContContainer>

        
        
    </Container>
  )
}

const ExternalContainer = styled.div`
        width: 100%;
        margin-top: 10px;
        /* border: 1px solid #D0D5DD; */
        border-bottom: 2px solid #D0D5DD;
        border-radius: 4px;
        /* outline: 1px solid #D0D5DD; */
        cursor: pointer;
`

const ContContainer = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 48% 48%;
    column-gap: 2rem;
    /* margin: 0 auto; */

    @media screen and (max-width: 600px){
        display: block;
    }
`

const LinkToDetails = styled(Link)`
    text-decoration: none;
    color: #000;
`

export const Title = styled.div`
    margin-top: 10px;
    padding-left: 20px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
    
    & h4{
        align-self: flex-start;
        font-weight: 600;
    }

    & h5{
        align-self: flex-start;
        font-size: 12px;
        color: ${colors.faint_text};

        & > p{
            font-size: 12px;
        }
    }
`




export {ExternalResources}